__turbopack_context__.v({
  "badge": "toggleButtonGroup-module-scss-module__UCFh1G__badge",
  "fitFull": "toggleButtonGroup-module-scss-module__UCFh1G__fitFull",
  "fitInline": "toggleButtonGroup-module-scss-module__UCFh1G__fitInline",
  "fitMdFull": "toggleButtonGroup-module-scss-module__UCFh1G__fitMdFull",
  "fitMdInline": "toggleButtonGroup-module-scss-module__UCFh1G__fitMdInline",
  "fitSmFull": "toggleButtonGroup-module-scss-module__UCFh1G__fitSmFull",
  "fitSmInline": "toggleButtonGroup-module-scss-module__UCFh1G__fitSmInline",
  "fitXlFull": "toggleButtonGroup-module-scss-module__UCFh1G__fitXlFull",
  "fitXlInline": "toggleButtonGroup-module-scss-module__UCFh1G__fitXlInline",
  "group": "toggleButtonGroup-module-scss-module__UCFh1G__group",
  "iconWrp": "toggleButtonGroup-module-scss-module__UCFh1G__iconWrp",
  "item": "toggleButtonGroup-module-scss-module__UCFh1G__item",
  "itemThemeFinsight": "toggleButtonGroup-module-scss-module__UCFh1G__itemThemeFinsight",
  "itemThemeLight": "toggleButtonGroup-module-scss-module__UCFh1G__itemThemeLight",
  "orientationHorizontal": "toggleButtonGroup-module-scss-module__UCFh1G__orientationHorizontal",
  "orientationVertical": "toggleButtonGroup-module-scss-module__UCFh1G__orientationVertical",
  "pressed": "toggleButtonGroup-module-scss-module__UCFh1G__pressed",
  "radiusM": "toggleButtonGroup-module-scss-module__UCFh1G__radiusM",
  "radiusS": "toggleButtonGroup-module-scss-module__UCFh1G__radiusS",
  "radiusXS": "toggleButtonGroup-module-scss-module__UCFh1G__radiusXS",
  "sizeM": "toggleButtonGroup-module-scss-module__UCFh1G__sizeM",
  "sizeS": "toggleButtonGroup-module-scss-module__UCFh1G__sizeS",
  "sizeXS": "toggleButtonGroup-module-scss-module__UCFh1G__sizeXS",
  "themeFinsight": "toggleButtonGroup-module-scss-module__UCFh1G__themeFinsight",
  "themeLight": "toggleButtonGroup-module-scss-module__UCFh1G__themeLight",
});
